import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, setToken } from "../lib/api";

declare global {
  interface Window {
    onTelegramAuth?: (user: Record<string, unknown>) => void;
  }
}

const BOT_USERNAME = import.meta.env.VITE_TG_BOT_USERNAME || "";
const DEV_MODE = import.meta.env.VITE_DEV_LOGIN === "1";

export function Login() {
  const nav = useNavigate();
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [devTgId, setDevTgId] = useState<string>("");

  useEffect(() => {
    window.onTelegramAuth = async (user) => {
      try {
        const r = await api.loginTelegram(user);
        setToken(r.token);
        nav("/");
      } catch (e: unknown) {
        setError(e instanceof Error ? e.message : String(e));
      }
    };

    if (BOT_USERNAME) {
      const script = document.createElement("script");
      script.src = "https://telegram.org/js/telegram-widget.js?22";
      script.async = true;
      script.setAttribute("data-telegram-login", BOT_USERNAME);
      script.setAttribute("data-size", "large");
      script.setAttribute("data-radius", "8");
      script.setAttribute("data-onauth", "onTelegramAuth(user)");
      script.setAttribute("data-request-access", "write");
      containerRef.current?.appendChild(script);
    }

    return () => { delete window.onTelegramAuth; };
  }, [nav]);

  async function devLogin() {
    setError(null);
    const id = parseInt(devTgId, 10);
    if (!Number.isFinite(id)) { setError("tg_id должен быть числом"); return; }
    try {
      const r = await fetch(`/api/auth/dev?tg_id=${id}`, { method: "POST" });
      if (!r.ok) throw new Error(await r.text());
      const data = await r.json();
      setToken(data.token);
      nav("/");
    } catch (e: unknown) {
      setError(e instanceof Error ? e.message : String(e));
    }
  }

  return (
    <div className="login">
      <h1>CRM Real Mind</h1>
      <p style={{ color: "var(--muted)", maxWidth: 360, textAlign: "center" }}>
        Войдите через Telegram. Доступ — только Денису @DenisCujba (менеджер)
        и Pavel @RealMindCorp (администратор).
      </p>
      <div ref={containerRef} />

      {DEV_MODE && (
        <div className="panel" style={{ marginTop: 16, width: 360 }}>
          <h3>Dev-вход</h3>
          <p style={{ color: "var(--muted)", fontSize: 12 }}>
            Telegram Login Widget не работает на localhost. В dev-режиме введи tg_id,
            который указан в <code>TG_ID_MANAGER</code> или <code>TG_ID_ADMIN</code>.
          </p>
          <div style={{ display: "flex", gap: 8 }}>
            <input
              placeholder="tg_id"
              value={devTgId}
              onChange={(e) => setDevTgId(e.target.value)}
              style={{ flex: 1 }}
            />
            <button className="primary" onClick={devLogin}>Войти</button>
          </div>
        </div>
      )}

      {error && <div className="error">{error}</div>}
    </div>
  );
}
